import React, {
  useState,
  Dispatch,
  SetStateAction,
  useEffect,
  useCallback,
  useMemo,
  useContext
} from "react";
import { useTranslation } from "../../context";
import { openModalTextBox } from "../../components/ModalTextBox";
import { _Team, _Category, _Space, _Active, _Type } from "../../components/CategoriesPicker/types";
import api from "../../api";
import { message } from "antd";
import CreateMenu from "../../components/CreateMenu";
import { isFocusEnv } from "@/utils";
import { notUseJoySpaceOffline, openLowCode } from "@/components/Joyspace/util";
import { useLocation } from "react-router-dom";
import qs from "query-string";
import { isMySpace } from "../../util";
import {
  folderType,
  folderTypeEnum,
  joyspacePermissionType
} from "../../config/permissions.config";
import events from "../../context/events";
import { PermissionEnum } from "../../const";
import openFolderModal from "../../contextModal/FolderModal";
import { Tabs } from "./config";
import { PageRouteName } from "../../batchOperate";
import { useNavigator } from "@/utils/NetworkCheck";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
interface IProps {
  currentRouterInfo?: any;
  disabledCreateFolder?: boolean;
}

export default function (props: IProps) {
  const { currentRouterInfo = {}, disabledCreateFolder = false } = props;
  const lang = useTranslation();
  const [activeId, setActiveId] = useState<string>("");
  const [canCreatePage, setCanCreatePage] = useState<boolean>(true);
  const [canCreateFolder, setCanCreateFolder] = useState<boolean>(true);
  const globalContext = useContext<GlobalContextConfig>(GlobalContext);
  const { appRuntimeEnv, onLine } = globalContext;
  const [isRoot, setIsRoot] = useState<boolean>(true);
  const location = useLocation();
  useEffect(() => {
    const query = qs.parse(location.search);
    if (query.categoryId) {
      setActiveId(query.categoryId as any);
      setIsRoot(false);
    } else {
      if (isMySpace(location.pathname)) {
        setActiveId(folderType.MY);
        setIsRoot(false);
      } else {
        setIsRoot(true);
        setActiveId(folderType.SHARE);
      }
    }
  }, [location]);
  useEffect(() => {
    if (!notUseJoySpaceOffline() && !onLine) {
      setCanCreatePage(!(currentRouterInfo.type === folderTypeEnum.SHARE));
      setCanCreateFolder(false);
      return;
    }
    if (isRoot) {
      setCanCreatePage(activeId === folderType.MY);
      setCanCreateFolder(true);
      return;
    }
    if (
      (currentRouterInfo.permissions &&
        !currentRouterInfo.permissions.includes(PermissionEnum.FOLDER_EDIT)) ||
      activeId === folderType.SHARE
    ) {
      setCanCreatePage(false);
      setCanCreateFolder(false);
    } else {
      setCanCreatePage(true);
      setCanCreateFolder(true);
    }
  }, [activeId, currentRouterInfo.permissions, currentRouterInfo.type, isRoot, onLine]);

  return (
    <CreateMenu
      canCreateFolder={canCreateFolder}
      canCreatePage={canCreatePage}
      disabledCreateFolder={disabledCreateFolder}
      folderId={activeId}
      lowCode={isFocusEnv() ? openLowCode : undefined}
      from={
        currentRouterInfo?.type === folderTypeEnum.SHARE
          ? PageRouteName.TEAM_SPACE
          : PageRouteName.MY_SPACE
      }
    />
  );
}
